import { motion } from "motion/react";
import { PageLayout } from "@/components/layout";

export default function PrivacyRoute() {
	return (
		<PageLayout>
			<section className="pt-16 md:pt-24 pb-16 md:pb-24 px-9 md:px-[8%] lg:px-[15%]">
				<div className="max-w-3xl mx-auto">
					<motion.h1
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6, delay: 0.2 }}
						className="font-sans text-[28px] md:text-[32px] lg:text-[42px] font-normal tracking-tight text-white mb-4"
					>
						Privacy Policy
					</motion.h1>
					<motion.p
						initial={{ opacity: 0, y: 15 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.5, delay: 0.35 }}
						className="text-[15px] text-white/30 mb-12"
					>
						Last updated: March 24, 2025
					</motion.p>

					<motion.div
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.5, delay: 0.4 }}
						className="space-y-10 text-[16px] text-white/50 leading-relaxed"
					>
						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Introduction</h2>
							<p>
								Basilica Digital Inc. ("Basilica," "we," "us," or "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website at basilica.digital or use our services.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Information We Collect</h2>
							<p className="mb-4">We may collect the following types of information:</p>
							<ul className="list-disc list-outside ml-5 space-y-2">
								<li><span className="text-white/70">Contact information</span> — such as your name and email address when you reach out to us or subscribe to communications.</li>
								<li><span className="text-white/70">Usage data</span> — such as your IP address, browser type, operating system, referring URLs, pages viewed, and dates and times of visits.</li>
								<li><span className="text-white/70">Device information</span> — such as device type, operating system version, and unique device identifiers.</li>
							</ul>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">How We Use Your Information</h2>
							<ul className="list-disc list-outside ml-5 space-y-2">
								<li>To provide, operate, and maintain our website and services.</li>
								<li>To communicate with you, including responding to inquiries and sending updates.</li>
								<li>To improve our website, products, and user experience.</li>
								<li>To detect, prevent, and address technical issues or security threats.</li>
								<li>To comply with legal obligations and enforce our terms.</li>
							</ul>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Sharing of Information</h2>
							<p>
								We do not sell your personal information. We may share your information with trusted third-party service providers who assist us in operating our website and conducting our business, subject to confidentiality obligations. We may also disclose information when required by law or to protect our rights.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Data Security</h2>
							<p>
								We implement reasonable administrative, technical, and physical security measures to protect your personal information. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Cookies and Tracking</h2>
							<p>
								Our website may use cookies and similar tracking technologies to enhance your experience. You can control cookie preferences through your browser settings. Disabling cookies may affect some features of our website.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Third-Party Links</h2>
							<p>
								Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites. We encourage you to review their privacy policies before providing any personal information.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Children's Privacy</h2>
							<p>
								Our services are not directed to individuals under the age of 13. We do not knowingly collect personal information from children. If we become aware that we have collected information from a child under 13, we will take steps to delete it promptly.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Your Rights</h2>
							<p>
								Depending on your jurisdiction, you may have the right to access, correct, delete, or restrict the processing of your personal information. To exercise these rights, please contact us at the address below.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Changes to This Policy</h2>
							<p>
								We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated revision date. Your continued use of our website after any changes constitutes acceptance of the updated policy.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Contact Us</h2>
							<p>
								If you have questions about this Privacy Policy, please contact us at:
							</p>
							<div className="mt-3 text-white/70">
								<p>Basilica Digital Inc.</p>
								<p>100 Enterprise Way</p>
								<p>Scotts Valley, CA 95066</p>
								<p className="mt-2">
									<a href="mailto:contact@basilica.digital" className="text-white/70 hover:text-white underline underline-offset-2 transition-colors">contact@basilica.digital</a>
								</p>
							</div>
						</div>
					</motion.div>
				</div>
			</section>
		</PageLayout>
	);
}
